import { LastEditorRecordProperty } from '@indigohive/cogfy-types'
import { FieldCellProps } from '../../FieldCell'
import clsx from 'clsx'

export type LastEditorCellProps = Pick<FieldCellProps<LastEditorRecordProperty>, 'property' | 'textWrap'>

export function LastEditorCell (props: LastEditorCellProps) {
  const { property, textWrap } = props

  return (
    <span
      className={clsx(
        'px-2 py-1',
        textWrap && 'whitespace-pre-wrap',
        !textWrap && 'truncate'
      )}
    >
      {property?.lastEditor?.value?.name}
    </span>
  )
}
